import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import media from "../../styles/media";

const base = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 28px;
  border: 2px solid transparent;
  border-radius: ${({ theme }) => theme.radii.md};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition:
    background-color ${({ theme }) => theme.transitions.base},
    border-color ${({ theme }) => theme.transitions.base},
    color ${({ theme }) => theme.transitions.base},
    transform ${({ theme }) => theme.transitions.base};

  &:hover {
    text-decoration: none;
    transform: translateY(-2px);
  }

  ${media.md} {
    padding: 12px 20px;
    font-size: ${({ theme }) => theme.fontSizes.sm};
  }
`;

const variants = {
  primary: css`
    background-color: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.onPrimary};

    &:hover {
      background-color: ${({ theme }) => theme.colors.primaryDark};
      border-color: ${({ theme }) => theme.colors.primaryDark};
      color: ${({ theme }) => theme.colors.onPrimary};
    }
  `,
  outline: css`
    background-color: transparent;
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};

    &:hover {
      border-color: ${({ theme }) => theme.colors.primaryDark};
      color: ${({ theme }) => theme.colors.primaryDark};
    }
  `,
  ghost: css`
    background-color: transparent;
    border-color: ${({ theme }) => theme.colors.onPrimary};
    color: ${({ theme }) => theme.colors.onPrimary};

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
      color: ${({ theme }) => theme.colors.onPrimary};
    }
  `,
};

const styles = css`
  ${base}
  ${({ $variant = "primary" }) => variants[$variant] ?? variants.primary}
  ${({ $fullWidth }) => $fullWidth && "width: 100%;"}
`;

export const Button = styled.button`
  ${styles}
`;

/** Тот же вид, но для внутренней навигации — без ручного `navigate()` в onClick. */
export const ButtonLink = styled(Link)`
  ${styles}
`;

/** Тот же вид для внешних ссылок и файлов. */
export const ButtonAnchor = styled.a`
  ${styles}
`;

export default Button;
